import dayjs from "dayjs";
import _ from "lodash";

let uuidBase = 0;

const appMixin = {
    data(): { uuid: number } {
        return {
            uuid: ++uuidBase
        };
    },
    methods: {
        capitalize(value: string): string {
            return _.capitalize(value);
        },
        capitalizeAll(value: string): string {
            return _.chain(value)
                .split(" ")
                .map(word => _.capitalize(word))
                .join(" ")
                .value();
        },
        formatCurrency(amount: number | string): string {
            if (typeof amount === "string") {
                amount = Number.parseFloat(amount);
            }

            return amount.toLocaleString("nl-BE", {
                style: "currency",
                currency: "EUR"
            });
        },
        formatDate(date: string): string {
            return dayjs(date).format("DD-MM-YYYY");
        },
        formatDatetime(date: string): string {
            return dayjs(date).format("DD-MM-YYYY HH:mm:ss");
        },
        formatValue(value: string | null | undefined): string {
            return value ?? "-";
        },
    }
};

export default appMixin;
